import { takeLatest, put, call } from 'redux-saga/effects';
import axiosInstance from 'clients/api';
import { setError } from '../error/slice';
import {
    AI_CHAT_CONVERSATIONS_CALL,
    AI_CHAT_MESSAGES_CALL,
    AI_CHAT_SEND_PROMPT_CALL,
    callAiConversations
} from './sagas-actions';
import {
    onCallConversations,
    onSuccessConversations,
    onFailedConversations,
    onCallMessages,
    onSuccessMessages,
    onFailedMessages,
    onCallSendPrompt,
    onSuccessSendPrompt,
    onFailedSendPrompt
} from './slice';
import {
    normalizeConversations,
    normalizeMessages,
    conversationIdFromPromptResponse,
    answerFromPromptResponse,
    toolSummaryFromTrace,
    downloadsFromResponse
} from './normalize';

export const PROMPT_TIMEOUT_MS = 120000;

export function* conversationsCallGenerator(action) {
    yield put(onCallConversations());
    try {
        const { data } = yield call(axiosInstance.get, '/mcp/conversations', { params: { limit: 20 } });
        yield put(onSuccessConversations(normalizeConversations(data)));
    } catch (error) {
        yield put(setError({ error, action }));
        yield put(onFailedConversations());
    }
}

export function* messagesCallGenerator(action) {
    const { conversationId } = action.payload;
    yield put(onCallMessages({ conversationId }));
    try {
        const { data } = yield call(axiosInstance.get, `/mcp/conversations/${conversationId}`);
        yield put(onSuccessMessages({
            conversationId,
            messages: normalizeMessages(data)
        }));
    } catch (error) {
        yield put(setError({ error, action }));
        yield put(onFailedMessages());
    }
}

export function* sendPromptCallGenerator(action) {
    const { prompt, conversationId, localMessageId, files = [] } = action.payload;
    yield put(onCallSendPrompt({
        prompt,
        conversationId,
        localMessageId,
        attachmentNames: files.map((file) => file.name)
    }));
    try {
        let body = conversationId
            ? { prompt, ai_conversation_id: conversationId }
            : { prompt };
        if (files.length) {
            body = new FormData();
            body.append('prompt', prompt);
            if (conversationId) body.append('ai_conversation_id', conversationId);
            files.forEach((file) => body.append('files', file, file.name));
        }
        const { data } = yield call(
            axiosInstance.post,
            '/mcp/prompt',
            body,
            { timeout: PROMPT_TIMEOUT_MS }
        );
        yield put(onSuccessSendPrompt({
            localMessageId,
            prompt,
            aiConversationId: conversationIdFromPromptResponse(data) || conversationId || null,
            answer: answerFromPromptResponse(data),
            toolSummary: toolSummaryFromTrace(data?.trace),
            downloads: downloadsFromResponse(data?.downloads)
        }));
        yield put(callAiConversations());
    } catch (error) {
        yield put(onFailedSendPrompt({ localMessageId, prompt }));
    }
}

export default function* aiChatWatcherSaga() {
    yield takeLatest(AI_CHAT_CONVERSATIONS_CALL, conversationsCallGenerator);
    yield takeLatest(AI_CHAT_MESSAGES_CALL, messagesCallGenerator);
    yield takeLatest(AI_CHAT_SEND_PROMPT_CALL, sendPromptCallGenerator);
}
